import styled from '@emotion/styled';

const ContentStyles = styled.div`
  padding: 2rem;
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
`;

export default ContentStyles;
